import axios from "axios";
import { toast } from "react-toastify";

// type = "gram" or "ounce"
export const getCachedPalladiumPrice = async (type = "gram") => {
  const cachedData = localStorage.getItem("palladiumPriceData");
  const today = new Date().toISOString().split("T")[0];

  if (cachedData) {
    const { pricePerOunce, date } = JSON.parse(cachedData);
    if (date === today) {
      return convertPalladiumPrice(pricePerOunce, type);
    }
  }

  try {
    const res = await axios.get("https://api.gold-api.com/price/XPD"); // returns USD/ounce
    const pricePerOunce = res.data.price; // e.g., 1295.00

    localStorage.setItem(
      "palladiumPriceData",
      JSON.stringify({ pricePerOunce, date: today })
    );

    return convertPalladiumPrice(pricePerOunce, type);
  } catch (error) {
    toast.error("Error fetching palladium price");
    return null;
  }
};

const convertPalladiumPrice = (pricePerOunce, type) => {
  if (type === "gram") {
    return (pricePerOunce / 31.1035).toFixed(2);
  } else {
    return pricePerOunce.toFixed(2);
  }
};
